import React, { useEffect, useState } from "react";
import "./expiredcerttable.css";
import { Table, Dropdown, Menu,message } from "antd";
import { BsThreeDots } from "react-icons/bs";
import { HiOutlineCursorClick } from "react-icons/hi";
import { MdOutlineNotificationsActive } from "react-icons/md";
import { RiExportLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import ImageModal from "../../Survelliance audit/IsoCertificationModal";
import RemainderModal from "../../Survelliance audit/remainder modal/RemainderModal";
import ExportModal from "../../Survelliance audit/export modal/ExportModal";
import { CloseOutlined } from "@ant-design/icons";
import Instance from "../../../AxiosConfig";
import { Form, Button } from "react-bootstrap";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const ExpiredCertificationTable = () => {
  const navigate = useNavigate();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isRemainderVisible, setIsRemainderVisible] = useState(false);
  const [isExportVisible, setIsExportVisible] = useState(false);
  const [expiredCertData,setExpiredCertData]=useState([]);
  const [search,setSearch]=useState("");
  const [status,setStatus]=useState("All");
  const [fromDate,setFromDate]=useState(null);
  const [toDate,setToDate]=useState(null);
  const [loading,setLoading]=useState(false);
  const itemsPerExpiredPage=10;
  const [currentPage,setCurrentPage]=useState(1);



  const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log("Selected Row Keys: ", selectedRowKeys);
    console.log("Selected Rows: ", selectedRows);
  },
};



  const handleMenuClick = ({ key }) => {
    if (key === "view") {
      setIsModalVisible(true);
    }
  };

  const handleModalClick = ({ key }) => {
  if (key === "view") {
    setIsModalVisible(true);
  } else if (key === "remainder") {
    setIsRemainderVisible(true);    
  } else if (key === "download") {
  const hide = message.open({
    type: "success",
    content: (
      <div className="custom-download-message">
        <span>File downloaded successfully!</span>
        <CloseOutlined className="close-icon" onClick={() => hide()} />
      </div>
    ),
    duration: 3, 
    style: {
      marginTop: "10vh",
    },
  });
}
};

const handleExpiredCertificationsData=async(page=1)=>{
  setLoading(true);
  const token=localStorage.getItem("token");
  try{
     const response=await Instance.get("ExpiredSurveillance",{
      params:{page,limit:itemsPerExpiredPage},
      headers:{
        Authorization:`Bearer ${token}`
      }
     })
     if(response.status==200 || response.status==201)
     {
      setExpiredCertData(response.data.certifications?.data || [])
      console.log("expireCert",response.data);
      
     }
  }
  catch(error){
        console.log("fetch error", error.response || error.message);
        
  }
  finally{
    setLoading(false)
  }
};


const handleFilter= async ()=>{
  setLoading(true);
  const token =localStorage.getItem("token");
  try{
     const params = {};
    if (search.trim()) params.companyName = search.trim();      
    if (status !== "All") params.status = status;
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    params.page=1;
    params.limit=itemsPerExpiredPage;
    const response = await Instance.get("/ExpiredSurveillance/filter", {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });

    console.log("Filter API response:", response.data);

    if (response.status === 200 || response.status === 201) {
      setExpiredCertData(response.data.certifications || []);
    
    } else {
      setExpiredCertData([]);
      message.warning("No records found for the given filters");
    }

  }catch (error) {
      console.error("Filter error:", error.response || error);
      message.error("Failed to fetch filtered data");
    } finally {
      setLoading(false);
      setCurrentPage(1);
    }

}

const handleClearFilters = ()=>{
  setSearch("")
  setStatus("All")
  setFromDate(null)
  setToDate(null)
  handleExpiredCertificationsData(1);
}

useEffect(()=>{
  handleExpiredCertificationsData();
},[]);

  const menu = (
    <Menu onClick={handleModalClick} className="custom-dropdown-menu">
      <Menu.Item key="view">View</Menu.Item>
      <Menu.Item key="remainder">Remainder</Menu.Item>
      <Menu.Item key="download">Download</Menu.Item>
    </Menu>
  );

  const columns = [
    {
      title: "Company Name",
      dataIndex: "companyName",
       
    },
    {
      title: "Certification Number",
      dataIndex: "certificationNumber",
      
    },
    {
      title: "Standard",
      dataIndex: "standard",
      
    },
    {
      title: "Expire Date",
      dataIndex: "expireDate",
       
    },
    {
      title: "Expire Since",
      dataIndex: "expireSince",
     
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Renewal Status",
      dataIndex: "renewalStatus",
       
      render: (text) => {
        let color = "";
        if (text?.toLowerCase() === "not connected") {
          color = "red";
        } else if (text?.toLowerCase() === "in process") {
          color = "orange";
        } else if (text?.toLowerCase() === "renewed") {
          color = "green";
        }
        return <span style={{ color }}>{text}</span>;
      },
    },

    {
      title: "Actions",
      key: "actions",
      render: () => (
        <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
          <BsThreeDots style={{ fontSize: "20px", cursor: "pointer" }} />
        </Dropdown>
      ),
    },
  ];

   
  return (
    <div>
      <div className="filter-card p-3">
        <Form>
          <div className="row g-3">
            <div className="col-md-3">
              <Form.Group>
                <Form.Label>Search</Form.Label>
                <Form.Control
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search..."
                />
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group>
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option>All</option>
                  <option>Active</option>
                  <option>Inactive</option>
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group>
                <Form.Label>From</Form.Label>
                <DatePicker
                  className="form-control"
                  value={fromDate ? dayjs(fromDate) : null}
                  onChange={(date) =>
                    setFromDate(date ? date.format("YYYY-MM-DD") : null)
                  }
                  format="YYYY-MM-DD"
                />
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group>
                <Form.Label>To</Form.Label>
                <DatePicker
                  className="form-control"
                  value={toDate ? dayjs(toDate) : null}
                  onChange={(date) =>
                    setToDate(date ? date.format("YYYY-MM-DD") : null)
                  }
                  format="YYYY-MM-DD"
                />
              </Form.Group>
            </div>
          </div>
        </Form>

        <div className="d-flex justify-content-end gap-4 my-3">
          <button className="clear-btn-company" onClick={handleClearFilters}>
            CLEAR FILTERS
          </button>
          <button className="clear-btn-company" onClick={handleFilter}>
            Submit
          </button>
        </div>
      </div>

      <div className="expired-certification-page mt-5">
        <div className="expired-certification-table mt-3">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="surve-heading-h1">Companies List</h1>
            <div className="d-flex align-items-center gap-3 table-header-buttons">
               
              <button
                className="surve-remainder-btn"
                onClick={() => setIsRemainderVisible(true)}
              >
                <MdOutlineNotificationsActive /> Remainder
              </button>
              <button
                className="surve-export-btn"
                onClick={() => setIsExportVisible(true)}
              >
                <RiExportLine /> Export
              </button>
            </div>
          </div>
          
          <div className="mt-4">
            <Table
              rowSelection={rowSelection}
              columns={columns}
              dataSource={expiredCertData || []}
              loading={loading}
              pagination={{
                pageSize:  itemsPerExpiredPage,
                current: currentPage,
                className: "custom-pagination",
              }}
              scroll={{ x: "max-content" }}
            />
          </div>
        </div>
      </div>

      <ImageModal
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
      />

      <RemainderModal
        visible={isRemainderVisible}
        onClose={() => setIsRemainderVisible(false)}
      />

      <ExportModal
        visible={isExportVisible}
        onClose={() => setIsExportVisible(false)}
      />
    </div>
  );
};

export default ExpiredCertificationTable;
